import { Outlet, Link } from 'react-router-dom';
import { useThemeAsset } from '@shared/configs';
import EFL_TEXT from '@shared/assets/pictures/efl_text_font.png';
import HALF_LOGO from '@shared/assets/pictures/eclipse_fitness_lv.png';
import EFL_WHITE_TEXT from '@shared/assets/pictures/efl-text-white.png';

export const AuthLayout = () => {
  const THEME_LOGO = useThemeAsset(EFL_TEXT, EFL_WHITE_TEXT);
  return (
    <div className="flex h-screen border-collapse overflow-hidden">
      <header className="supports-backdrop-blur:bg-background/60 absolute left-0 right-0 top-0 z-20 border-b bg-background/95 backdrop-blur">
        <nav className="h-15 flex items-center justify-between px-4">
          <Link
            to={'/'}
            className="flex items-center justify-between gap-2 md:flex"
          >
            <img src={HALF_LOGO} alt="efl-half-logo" width={45} />
            <img src={THEME_LOGO} alt="efl-logo-text" height={55} width={175} />
          </Link>
        </nav>
      </header>
      <main className="flex-1 overflow-y-auto overflow-x-hidden bg-secondary/10 pb-1 pt-16">
        <Outlet />
      </main>
    </div>
  );
};
